import {
  CalendarIcon,
  CopyIcon,
  KebabHorizontalIcon,
  ListOrderedIcon,
  PencilIcon,
  PlusIcon,
  SyncIcon,
  TrashIcon
} from "@primer/octicons-react";

import { ActionList, ActionMenu, Box, IconButton, Label, SegmentedControl } from "@primer/react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Transition } from "semantic-ui-react";
import { hinhThucMienGiamApi } from "../../api/hinhThucMienGiamApi";
import { hinhThucMienGiamGroupApi } from "../../api/hinhThucMienGiamGroupApi";
import { AnimationConfirm } from "../../components/confirm";
import DataGrid from "../../components/data-grid";
import { IDataGridColumn } from "../../components/data-grid/type/IDataGridProps";
import SelectBoxMultipleNhomMienGiam from "../../components/selectbox-multiple-nhommiengiam";
import Button from "../../components/ui/button";
import TextWithEllipse from "../../components/ui/text-with-ellipse";
import { PageBaseStatus } from "../../models/pageBaseStatus";
import { sf_hinhthucmiengiam } from "../../models/response/category/sf_hinhthucmiengiam";
import { sf_hinhthucmiengiam_hinhthuctinh } from "../../models/response/category/sf_hinhthucmiengiam_hinhthuctinh";
import { sf_hinhthucmiengiam_group } from "../../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam_group";
import {
  changeHinhThucMienGiamNamHocAction,
  closeHinhThucMienGiamCopyModalAction,
  closeHinhThucMienGiamDeleteConfirm,
  closeHinhThucMienGiamDetailModal,
  deleteHinhThucMienGiamStart,
  loadHinhThucMienGiamStart,
  showHinhThucMienGiamCopyModalAction,
  showHinhThucMienGiamDeleteConfirm,
  showHinhThucMienGiamDetailModal,
} from "../../state/actions/hinhThucMienGiamActions";
import { RootState } from "../../state/reducers";
import { MienGiamCopyModal } from "./copy_modal";
import HinhThucMienGiamWizardModal from "./HinhThucMienGiamWizardModal";


const salesetRegisterTypes = [
  { id: 10, text: "Theo năm" },
  { id: 5, text: "Theo kỳ" },
  { id: 13, text: "Theo tháng" },
];

const HinhThucMienGiamPage = () => {
  const state = useSelector((state: RootState) => state.hinhThucMienGiam);
  const { nam_hoc: param_nam_hoc, dm_coso_id } = useSelector(
    (x: RootState) => x.common
  );
  const [sf_hinhthucmiengiam_group, set_sf_hinhthucmiengiam_group] = useState<
    sf_hinhthucmiengiam_group[]
  >([]);
  const [danhSachMienGiamSelectId, setDanhSachMienGiamSelectId] = useState<
    number[]
  >([]);
  const [nhomMienGiamFilter, setNhomMienGiamFilter] = useState<number[]>([]);
  const [hinhthucmiengiam_hinhthuctinhs, set_hinhthucmiengiam_hinhthuctinhs] =
    useState<sf_hinhthucmiengiam_hinhthuctinh[]>([]);
  const [statusFilter, setStatusFilter] = useState<number>(0);

  const dispatch = useDispatch();
  const {
    status,
    sf_hinhthucmiengiams,
    is_show_detail_modal,
    is_show_delete_confirm,
    sf_hinhthucmiengiam_editing,
    nam_hoc,
    is_show_copy_modal,
  } = state;
  const [wizardInitialStep, setWizardInitialStep] = useState<1 | 2>(1);

  useEffect(() => {
    dispatch(changeHinhThucMienGiamNamHocAction(param_nam_hoc));
  }, [param_nam_hoc]);

  useEffect(() => {
    handleReloadHinhThucMienGiamGroup();
    dispatch(loadHinhThucMienGiamStart(nam_hoc));
    handleReloadHinhThucTinh();
  }, [nam_hoc]);

  useEffect(() => {
    handleReloadHinhThucMienGiamGroup();
    dispatch(loadHinhThucMienGiamStart(nam_hoc));
    handleReloadHinhThucTinh();
  }, []);

  const handleCloseDeleteConfirm = useCallback(() => {
    dispatch(closeHinhThucMienGiamDeleteConfirm());
  }, []);

  const handleShowDeleteConfirm = useCallback(() => {
    dispatch(showHinhThucMienGiamDeleteConfirm());
  }, []);

  const handleBtnEditClicked = (data: sf_hinhthucmiengiam) => {
    setWizardInitialStep(1);
    dispatch(showHinhThucMienGiamDetailModal(data));
  };

  const handleBtnAdjustItemsClicked = (data: sf_hinhthucmiengiam) => {
    setWizardInitialStep(2);
    dispatch(showHinhThucMienGiamDetailModal(data));
  };

  const handleConfirmDelete = useCallback(() => {
    dispatch(deleteHinhThucMienGiamStart(danhSachMienGiamSelectId));
    setTimeout(() => {
      dispatch(loadHinhThucMienGiamStart(nam_hoc));
    }, 500);
  }, [dispatch, danhSachMienGiamSelectId]);

  const handleCloseDetailModal = useCallback((shouldReload?: boolean) => {
    dispatch(closeHinhThucMienGiamDetailModal());
    setWizardInitialStep(1);
    if (shouldReload) {
      dispatch(loadHinhThucMienGiamStart(nam_hoc));
    }
  }, [dispatch, nam_hoc]);

  const handleReloadHinhThucMienGiamGroup = async () => {
    const res = await hinhThucMienGiamGroupApi.selectAll();
    if (res.is_success) {
      set_sf_hinhthucmiengiam_group(
        res.data.filter((x: any) => x.dm_coso_id == dm_coso_id)
      );
    }
  };

  const handleReloadHinhThucTinh = async () => {
    const res = await hinhThucMienGiamApi.select_hinhthuctinhs();
    if (res.is_success) {
      set_hinhthucmiengiam_hinhthuctinhs(res.data);
    }
  };

  const dataSource = useMemo(() => {
    let sortAppends = [
      ...sf_hinhthucmiengiams.filter(
        (x) => x.dm_coso_id === dm_coso_id
      ),
    ];
    if (nhomMienGiamFilter.length > 0) {
      sortAppends = sortAppends.filter((x) =>
        nhomMienGiamFilter.includes(x.sf_hinhthucmiengiam_group_id)
      );
    }

    const now = new Date();
    if (statusFilter === 1) { // Khả dụng
      sortAppends = sortAppends.filter((x) => {
        const start = x.tu_ngay ? new Date(x.tu_ngay) : null;
        const end = x.den_ngay ? new Date(x.den_ngay) : null;
        return (
          (!start || now >= start) && (!end || now <= end)
        );
      });
    } else if (statusFilter === 2) { // Sắp diễn ra
      sortAppends = sortAppends.filter((x) => {
        const start = x.tu_ngay ? new Date(x.tu_ngay) : null;
        return start && now < start;
      });
    } else if (statusFilter === 3) { // Hết hạn
      sortAppends = sortAppends.filter((x) => {
        const end = x.den_ngay ? new Date(x.den_ngay) : null;
        return end && now > end;
      });
    }

    return sortAppends;
  }, [sf_hinhthucmiengiams, nhomMienGiamFilter, dm_coso_id, nam_hoc, statusFilter]);

  const columns = useMemo<IDataGridColumn[]>(() => {
    const currentDate = new Date();
    return [
      {
        id: "actions",
        caption: "#",
        width: 80,
        align: "center",
        fixed: "left",
        cellRender: (data: any) => (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <ActionMenu>
              <ActionMenu.Anchor>
                <IconButton
                  aria-label="Thao tác"
                  icon={KebabHorizontalIcon}
                  variant="invisible"
                  size="small"
                  sx={{
                    minWidth: "24px",
                    minHeight: "24px",
                    padding: "2px",
                  }}
                />
              </ActionMenu.Anchor>
              <ActionMenu.Overlay>
                <ActionList showDividers>
                  <ActionList.Item
                    onSelect={() => {
                      handleBtnAdjustItemsClicked(data);
                    }}
                  >
                    <ActionList.LeadingVisual>
                      <ListOrderedIcon />
                    </ActionList.LeadingVisual>
                    Điều chỉnh khoản miễn giảm
                  </ActionList.Item>
                  <ActionList.Item
                    onSelect={() => {
                      handleBtnEditClicked(data);
                    }}
                  >
                    <ActionList.LeadingVisual>
                      <PencilIcon />
                    </ActionList.LeadingVisual>
                    Chỉnh sửa
                  </ActionList.Item>
                  <ActionList.Item
                    variant="danger"
                    onSelect={() => {
                      setDanhSachMienGiamSelectId([data.id]);
                      handleShowDeleteConfirm();
                    }}
                  >
                    <ActionList.LeadingVisual>
                      <TrashIcon />
                    </ActionList.LeadingVisual>
                    Xóa
                  </ActionList.Item>
                </ActionList>
              </ActionMenu.Overlay>
            </ActionMenu>
          </Box>
        ),
      },
      {
        caption: "Nhóm miễn giảm",
        id: "sf_hinhthucmiengiam_group_id",
        dataField: "sf_hinhthucmiengiam_group_id",
        width: 150,
        cellRender: (data: any) => {
          const group = sf_hinhthucmiengiam_group
            .filter((c) => c.dm_coso_id === dm_coso_id)
            .find((g) => g.id === data.sf_hinhthucmiengiam_group_id);
          const text = group
            ? `(${group.thu_tu}) ${group.ten_nhom_mien_giam}`
            : "";
          return <TextWithEllipse text={text} lineNumber={1} />;
        },
      },
      {
        caption: "Mã miễn giảm",
        id: "ma_hinh_thuc",
        dataField: "ma_hinh_thuc",
        width: 130,
        align: "left",
        fixed: "left",
        cellRender: (data: any) => {
          return (
            <Box>
              <span style={{ fontWeight: 700, marginLeft: 2 }}>
                <Label variant="accent">
                  {data.ma_nhom_mien_giam}-{data.ma_hinh_thuc}
                </Label>
              </span>
            </Box>
          );
        },
      },
      {
        caption: "Tên miễn giảm",
        id: "hinh_thuc_mien_giam",
        dataField: "hinh_thuc_mien_giam",
        width: 150,
        align: "left",
        cellRender: (data: any) => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <TextWithEllipse
              text={data.hinh_thuc_mien_giam || ""}
              lineNumber={1}
            />
          </div>
        ),
      },
      {
        caption: "Hình thức tính",
        id: "sf_hinhthucmiengiam_hinhthuctinh_id",
        dataField: "sf_hinhthucmiengiam_hinhthuctinh_id",
        width: 150,
        align: "left",
        cellRender: (data: any) => {
          const group = hinhthucmiengiam_hinhthuctinhs.find(
            (g) => g.id === data.sf_hinhthucmiengiam_hinhthuctinh_id
          );
          return (
            <TextWithEllipse
              text={group?.hinh_thuc_tinh || ""}
              lineNumber={1}
            />
          );
        },
      },
      {
        caption: "Thời gian áp dụng",
        id: "tu_ngay",
        dataField: "tu_ngay",
        width: 220,
        align: "left",
        cellRender: (data: any) => {
          const formatDate = (date: string | Date | null) => {
            if (!date) return "";
            return new Intl.DateTimeFormat("vi-VN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }).format(new Date(date));
          };
          return (
            <Box>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  fontWeight: 500,
                }}
              >
                <span style={{ color: "green" }}>
                  <CalendarIcon size={16} />
                </span>
                <span>{formatDate(data.tu_ngay)}</span>
                <span>-</span>
                <span style={{ color: "red" }}>
                  <CalendarIcon size={16} />
                </span>
                <span>{formatDate(data.den_ngay)}</span>
              </div>
            </Box>
          );
        },
      },
      {
        caption: "Trạng thái",
        id: "den_ngay",
        dataField: "den_ngay",
        width: 130,
        cellRender: (data: any) => {
          const now = new Date();
          const startDate = data.tu_ngay ? new Date(data.tu_ngay) : null;
          const endDate = data.den_ngay ? new Date(data.den_ngay) : null;

          if (startDate && now < startDate) {
            return (
              <Box>
                <Label variant="attention">Sắp diễn ra</Label>
              </Box>
            );
          }
          if (endDate && now > endDate) {
            return (
              <Box>
                <Label variant="danger">Hết hạn</Label>
              </Box>
            );
          }
          return (
            <Box>
              <Label variant="success">Khả dụng</Label>
            </Box>
          );
        },
      },
      {
        caption: "Áp dụng toàn trường",
        id: "is_apdung_toantruong",
        dataField: "is_apdung_toantruong",
        width: 200,
        align: "center",
        cellRender: (data: any) => (
          <input
            type="checkbox"
            checked={data.is_apdung_toantruong === true}
            readOnly
            style={{ cursor: "default" }}
          />
        ),
      },
      {
        caption: "Áp dụng cho hình thức nộp",
        id: "sf_saleset_register_type_id",
        dataField: "sf_saleset_register_type_id",
        width: 210,
        cellRender: (data: any) => {
          const salesetRegisterType = salesetRegisterTypes.find(
            (x) => x.id === data.sf_saleset_register_type_id
          );
          return <TextWithEllipse text={salesetRegisterType?.text || ""} lineNumber={1} />;
        },
      },
    ];
  }, [
    sf_hinhthucmiengiams,
    hinhthucmiengiam_hinhthuctinhs,
    sf_hinhthucmiengiam_group,
    handleBtnEditClicked,
  ]);

  return (
    <React.Fragment>
      <Box sx={{ p: 2 }}>
        <Transition
          animation="scale"
          visible={true}
          duration={100}
          transitionOnMount={true}
        >
          <Box>
            <DataGrid
              dataSource={dataSource}
              columns={columns}
              keyExpr="id"
              height={window.innerHeight - 170}
              isLoading={status === PageBaseStatus.is_loading}
              searchEnable={true}
              isShowRowIdx={false}
              title={
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box sx={{ fontSize: 16, fontWeight: 600 }}>
                    Danh sách hình thức miễn giảm
                  </Box>
                  <SegmentedControl size="small" sx={{ width: "fit-content", ml: 1 }}>
                    <SegmentedControl.Button
                      selected={statusFilter === 0}
                      onClick={() => setStatusFilter(0)}
                    >
                      Tất cả
                    </SegmentedControl.Button>
                    <SegmentedControl.Button
                      selected={statusFilter === 1}
                      onClick={() => setStatusFilter(1)}
                    >
                      Khả dụng
                    </SegmentedControl.Button>
                    <SegmentedControl.Button
                      selected={statusFilter === 2}
                      onClick={() => setStatusFilter(2)}
                    >
                      Sắp diễn ra
                    </SegmentedControl.Button>
                    <SegmentedControl.Button
                      selected={statusFilter === 3}
                      onClick={() => setStatusFilter(3)}
                    >
                      Hết hạn
                    </SegmentedControl.Button>
                  </SegmentedControl>
                </Box>
              }
              actionComponent={
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <SelectBoxMultipleNhomMienGiam
                    value={nhomMienGiamFilter}
                    onValueChanged={(value) => {
                      setNhomMienGiamFilter(value === null ? [] : value);
                    }}
                    size="small"
                  />
                  <Button
                    size="small"
                    variant="default"
                    leadingVisual={SyncIcon}
                    onClick={() => dispatch(loadHinhThucMienGiamStart(nam_hoc))}
                  >
                    Làm mới
                  </Button>
                  <Button
                    size="small"
                    variant="primary"
                    leadingVisual={PlusIcon}
                    onClick={() => {
                      setWizardInitialStep(1);
                      dispatch(showHinhThucMienGiamDetailModal(undefined));
                    }}
                  >
                    Thêm mới
                  </Button>
                  <Button
                    size="small"
                    leadingVisual={CopyIcon}
                    variant="primary"
                    onClick={() =>
                      dispatch(showHinhThucMienGiamCopyModalAction())
                    }
                  >
                    Sao chép từ năm học cũ
                  </Button>
                </Box>
              }
              paging={{
                enable: true,
                pageSize: 50,
                pageSizeItems: [50, 200, 500, 1000],
              }}
              exportConfig={{
                enable: true,
              }}
              filterRow={{
                enable: true,
              }}
            />
          </Box>
        </Transition>

        {is_show_detail_modal && (
          <HinhThucMienGiamWizardModal
            onClose={handleCloseDetailModal}
            onChanged={() => {
              dispatch(loadHinhThucMienGiamStart(nam_hoc));
            }}
            sf_hinhthucmiengiam={sf_hinhthucmiengiam_editing}
            nam_hoc={nam_hoc}
            initialStep={wizardInitialStep}
          />
        )}
        {is_show_delete_confirm && (
          <AnimationConfirm
            onClose={handleCloseDeleteConfirm}
            onConfirmed={handleConfirmDelete}
            text={`Bạn có chắc chắn muốn xóa hình thức miễn giảm đã chọn ?`}
            is_saving={status === PageBaseStatus.is_deleting}
            text_close_button="Không xóa"
            text_confirm_button="Xóa miễn giảm"
            type="danger"
            animationOf={`#ListItem${danhSachMienGiamSelectId[0]}`}
          />
        )}

        {is_show_copy_modal && nam_hoc && (
          <MienGiamCopyModal
            nam_hoc_to={nam_hoc}
            animationOf="#btnInsert"
            onClose={() => {
              dispatch(closeHinhThucMienGiamCopyModalAction());
            }}
            onSuccess={() => {
              dispatch(closeHinhThucMienGiamCopyModalAction());
              dispatch(loadHinhThucMienGiamStart(nam_hoc));
            }}
          />
        )}
      </Box>
    </React.Fragment>
  );
};
export default HinhThucMienGiamPage;
